angular.module('unergie.main')
.controller('enedisCallsCtrl', ($scope, $state, DataAccess, DataAccessSearch, TableGeneratorService, XmlParser, AlertManager, DownloadService, ErrorCatcher) => {
    $scope.enedisCalls = {}
    $scope.enedisCalls.columns = {
        id: { label: 'ID', mode: 'search_operator' },
        id_contract: { label: 'ID Contrat', mode: 'search_wildcard' },
        id_prm: { label: 'PRM', mode: 'search_wildcard' },
        webservice: { label: 'Webservice', mode: 'search_wildcard' },
        webservice_version: { label: 'Version', mode: 'search_wildcard' },
        code: { label: 'Code retour', mode: 'search_wildcard' },
        comments: { label: 'Commentaires', mode: 'search_wildcard' },
        id_grd_contract: { label: 'Contrat GRD', mode: 'search_wildcard' },
        request_id: { label: 'ID request', mode: 'search_wildcard' },
        duration: { label: 'Durée', mode: 'search_operator' },
        req_file: { label: 'Fichier demande', mode: 'hidden' },
        res_file: { label: 'Fichier retour', mode: 'hidden' },
        creation_ts: { label: 'Date', mode: 'search_date' },
    }

    const transformData = function (data) {
        let lastDate = null
        let alternate = false
        return data.forEach((call) => {
            if ((lastDate === null) || !moment(call.creation_ts).startOf('day').isSame(lastDate)) {
                alternate = !alternate
                lastDate = moment(call.creation_ts).startOf('day')
            }
            call.alternate = alternate
        })
    }

    $scope.download = (file) => DownloadService.downloadFile(`/api-admin/s3-download?file=${file}`)

    $scope.refresh = () => TableGeneratorService.getTable($scope.enedisCalls, 'enedis-calls', ['label'], transformData, { orderBy: '-creation_ts' })

    $scope.refresh()

    $scope.isActive = (state) => $state.is(state)
})
